
import { defineComponent } from "vue";

import Header from "@/components/CarouselHeader.vue";
import Stats from "@/components/Stats.vue";
import CareerList from "@/components/Careers/Template1/CareersList.vue";

export default defineComponent({
  components: {
    Header,
    Stats,
    CareerList,
  },
  data() {
    return {
      bgIMG: require("@/assets/img/doctors-banner.png"),
    };
  },
});
